// extracted by mini-css-extract-plugin
export default {"open-in-spotify-button":"OpenInSpotifyButton_open-in-spotify-button__6F+HA"};